<template>
  <div class="previewable-image">
    <template v-if="src">
      <div class="previewable-image__actions">
        <button
          type="button"
          class="btn btn-primary btn-sm"
          @click="showPreview = true"
        >
          <i class="bi bi-arrows-fullscreen mr-1" /> Preview
        </button>

        <button
          type="button"
          class="btn btn-outline-secondary btn-sm"
          @click="openOriginal"
        >
          <i class="bi bi-box-arrow-up-right mr-1" /> Open original
        </button>
      </div>

      <div class="previewable-image__image-wrap">
        <img
          :src="src"
          :alt="alt"
          class="previewable-image__img img-fluid"
          @click="showPreview = true"
        >
      </div>

      <div
        v-if="showPreview"
        class="previewable-image__modal"
        :style="{ top: `${topOffset}px`, '--top-offset': `${topOffset}px` }"
        @click="showPreview = false"
      >
        <button
          type="button"
          class="previewable-image__modal-close"
          @click.stop="showPreview = false"
        >
          ×
        </button>

        <div
          class="previewable-image__modal-content"
          @click.stop
        >
          <img
            :src="src"
            :alt="alt"
            class="previewable-image__modal-img"
          >
        </div>
      </div>
    </template>
  </div>
</template>

<script>
export default {
  name: 'PreviewableImage',

  props: {
    src: {
      type: String,
      default: '',
    },
    alt: {
      type: String,
      default: 'preview-image',
    },
    topOffset: {
      type: Number,
      default: 0,
    }
  },

  data() {
    return {
      showPreview: false,
    };
  },

  methods: {
    openOriginal() {
      if (!this.src) {
        return;
      }

      const url = this.normalizeOpenOriginalUrl(this.src);
      window.open(url, '_blank', 'noopener');
    },

    normalizeOpenOriginalUrl(src) {
      try {
        const url = new URL(src, window.location.origin);
        if (url.pathname === '/share') {
          url.searchParams.set('view', '1');
          url.searchParams.delete('lightweight');
        }
        return url.toString();
      } catch (e) {
        if (typeof src === 'string' && src.includes('/share?')) {
          const glue = src.includes('?') ? '&' : '?';
          return src.includes('view=') ? src : `${src}${glue}view=1`;
        }
        return src;
      }
    },
  },
};
</script>

<style scoped lang="scss">
.previewable-image {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;

  &__actions {
    display: flex;
    gap: 8px;
    flex-wrap: wrap;
    justify-content: center;
  }

  &__image-wrap {
    display: inline-block;
  }

  &__img {
    cursor: zoom-in;
    max-width: 500px;
    border-radius: 8px;
    transition: transform 0.15s ease, box-shadow 0.15s ease;

    &:hover {
      transform: scale(1.02);
      box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);
    }
  }

  &__modal {
    --modal-padding: 20px;

    position: fixed;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 1100;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: var(--modal-padding);
    background: rgba(0, 0, 0, 0.85);
  }

  &__modal-content {
    display: flex;
    align-items: center;
    justify-content: center;
    max-width: 100%;
    max-height: 100%;
    overflow: hidden;
  }

  &__modal-img {
    display: block;
    max-width: calc(100vw - (var(--modal-padding) * 2));
    max-height: calc(100vh - (var(--modal-padding) * 2) - var(--top-offset, 0px));
    width: auto;
    height: auto;
    object-fit: contain;
  }

  &__modal-close {
    position: absolute;
    top: 20px;
    right: 20px;
    z-index: 1101;
    width: 44px;
    height: 44px;
    border: none;
    border-radius: 50%;
    background: rgba(15, 23, 42, 0.85);
    color: #fff;
    font-size: 24px;
    line-height: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;

    &:hover {
      background: rgba(15, 23, 42, 1);
    }
  }
}
</style>
